import { PaletteMode } from '@mui/material';

export const light = {
    alternate: {
        main: '#F5FAFF',
        dark: '#ECECE9',
    },
    cardShadow: 'rgba(23, 70, 161, .11)',
    mode: 'light' as PaletteMode,
    primary: {
        main: '#3F57B2',
        light: '#3F57B2',
        dark: '#3F57B2',
        contrastText: '#fff',
    },
    secondary: {
        light: '#19B96B',
        main: '#3FB549',
        dark: '#19B96B',
        contrastText: '#fff',
    },
    success: {
        light: '#3FB549',
        main: '#3FB549',
        dark: '#3FB549',
        contrastText: '#fff',
    },
    error: {
        light: '#F04438',
        main: '#F04438',
        dark: '#F04438',
        contrastText: '#fff',
    },
    text: {
        primary: '#2e313f',
        secondary: '#6C6B6C',
        success: '#dff0d8',
    },
    divider: '#EAECF0',
    background: {
        paper: '#ffffff',
        default: '#F5FAFF',
        level1: '#F9FAFB',
        level2: '#F2F4F7',
        green: '#dff0d8',
        footer: '#ECECE9',
    },

    common: {
        green: '#d6e9c6',
        headingGreen: '#00703C',
        denim: '#6dbff6',
        _a: '#337ab7',
        _b: '#419641',
        _c: '#eb9316',
        _d: '#996666',
        _e: '#666',
        _f: '#0099ff',
        _g: '#cc3333',
    },
    link: {
        main: '#212E5E',
        light: '#332F2F',
        hover: '#19B96B',
    },
};

export const dark = {
    alternate: {
        main: '#1a2138',
        dark: '#151a30',
    },
    cardShadow: 'rgba(0, 0, 0, .11)',
    common: {
        black: '#000',
        white: '#fff',
    },
    mode: 'dark' as PaletteMode,
    primary: {
        main: '#1976d2',
        light: '#2196f3',
        dark: '#0d47a1',
        contrastText: '#fff',
    },
    secondary: {
        light: '#FFEA41',
        main: '#FFE102',
        dark: '#DBBE01',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    text: {
        primary: '#EEEEEF',
        secondary: '#AEB0B4',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#222B45',
        default: '#222B45',
        level2: '#333',
        level1: '#2D3748',
    },
};
